import {
    type ContactMessageIntent,
    contactMessageIntentSchema,
    contactQuestionSchema,
    DEFAULT_CONTACT_MESSAGE_INTENT,
} from "@wags/profile-contracts/contact-session.contract.ts";

export function parseProviderOutreachSearch(
    search: Record<string, string | string[] | null | undefined>,
): { intent: ContactMessageIntent; question?: string } {
    return {
        intent: contactMessageIntentSchema
            .catch(DEFAULT_CONTACT_MESSAGE_INTENT)
            .parse(search.intent),
        question: contactQuestionSchema
            .optional()
            .catch(undefined)
            .parse(search.question ?? undefined),
    };
}
